import { render, staticRenderFns } from "./AdminUsersForm.vue?vue&type=template&id=00897a4f&"
import script from "./AdminUsersForm.vue?vue&type=script&lang=js&"
export * from "./AdminUsersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports